// src/com/current_plan_stat_with_rent/CurrentPlanStatWithRentGql.js
import { gql } from "@apollo/client";

/* ************************************************
 * CURRENT_PLAN_STAT_WITH_RENT Apollo Graphql
 * VIEW
 * Project: NewTOP for cloud
 * 2025-02-05 09:20:17 using DbdbTap.
 * https://www.dbdbtap.com
 ************************************************ */

const CURRENT_PLAN_STAT_WITH_RENT_LIST_PART = gql`
fragment CurrentPlanStatWithRentListPart on CurrentPlanStatWithRent {
    dcCd
    dcName
    dcTypeCd
    dcTypeName
    transRequest
    rented
    planned
    plannedRent
    leftDc
    leftRent
    assignDc
    assignRent
    waitDc
    waitRent
}
`;


export const LIST_CURRENT_PLAN_STAT_WITH_RENT = gql`
${CURRENT_PLAN_STAT_WITH_RENT_LIST_PART}
query ListCurrentPlanStatWithRent {
    currentPlanStatWithRentList {
        ...CurrentPlanStatWithRentListPart
    }
}
`;

export const CurrentPlanStateColumnKey = {
    transRequest: {valueKey: 'transRequest', label: '운송요청', color: 'cyan'},
    planned: {valueKey: 'planned', label: '출차계획', color: 'lightgreen'},
    leftDc: {valueKey: 'leftDc', label: '출차완료', color: '#d8f'},
    assignDc: {valueKey: 'assignDc', label: '출차대기', color: 'orange'},
    waitDc: {valueKey: 'waitDc', label: '배차대기', color: '#fcf'},
};

export const CurrentPlanStateColumns = [
    CurrentPlanStateColumnKey.transRequest,
    CurrentPlanStateColumnKey.planned,
    CurrentPlanStateColumnKey.leftDc,
    CurrentPlanStateColumnKey.assignDc,
    CurrentPlanStateColumnKey.waitDc,
];

export const CurrentPlanStateColumnsForChart = [
    CurrentPlanStateColumnKey.planned,
    CurrentPlanStateColumnKey.leftDc,
    CurrentPlanStateColumnKey.assignDc,
    CurrentPlanStateColumnKey.waitDc,
];

/*
Express:
    출차계획/운송요청 (%) : planned/transRequest
    출차완료/운송요청 (%) : leftDc/transRequest
    출차대기/출차완료 (%) : assignDc/transRequest
    배차대기/출차완료 (%) : waitDc/transRequest
*/

const MakeRatesForDc = [
    '930', // Exp.남사
    '934', // Exp.오산
    '910', // Exp.함안
];

export function makeCurrantPlanStateTree(list) {
    // Tree: dcType -> dcCd = {...}
    const typeMap = {};
    const tree = [];
    const total = {transRequest:0, planned:0, leftDc:0, assignDc:0, waitDc:0};
    let index = 0;
    list.forEach(rec => {
        if(!typeMap[rec.dcTypeCd]) {
            typeMap[rec.dcTypeCd] = {dcTypeCd:rec.dcTypeCd, dcTypeName:rec.dcTypeName, dcList:[]};
            tree.push(typeMap[rec.dcTypeCd]);
        }
        const data = {...rec};
        if(MakeRatesForDc.includes(rec.dcCd)) {
            if(rec.transRequest) {
                data.plannedRate = Math.round(rec.planned * 100 / rec.transRequest);
                data.leftRate = Math.round(rec.leftDc * 100 / rec.transRequest);
                data.assignRate = Math.round(rec.assignDc * 100 / rec.transRequest);
                data.waitRate = Math.round(rec.waitDc * 100 / rec.transRequest);
            }
            else {
                data.plannedRate = 0;
                data.leftRate = 0;
                data.assignRate = 0;
                data.waitRate = 0;
            }
            data.usePercent = true;
        }
        else data.usePercent = false;
        data.index = index++;

        data.dcLabel = rec.dcName.replace(/[.a-zA-Z]/g, '');
        typeMap[rec.dcTypeCd].dcList.push(data);

        total.transRequest += rec.transRequest;
        total.planned += rec.planned;
        total.leftDc += rec.leftDc;
        total.assignDc += rec.assignDc;
        total.waitDc += rec.waitDc;
    });
    return {tree, total};
}